export default __webpack_public_path__ + "static/media/highlight-11-new.43ff28b7.jpg";